export interface ExploreTrip {
  id: number;
  title: string;
  author: string;
  authorImg: string;
  country: string;
  city: string;
  imageUrl: string;
  tags: string[];
  budget: 1 | 2 | 3;
  people: 'solo' | 'couple' | 'small group' | 'large group';
  duration: string;
  createdDaysAgo: number;
  saves: number;
}

export interface ExploreRecommendation {
  tripId: number;
  why: string;
}

export const exploreTrips: ExploreTrip[] = [
  { id: 1, title: 'Ring Road & Waterfalls', author: 'Freya H.', authorImg: 'https://i.pravatar.cc/60?img=32', country: 'Iceland', city: 'Reykjavík', imageUrl: 'https://images.unsplash.com/photo-1504829857797-ddff29c27927?w=700&q=80&auto=format&fit=crop', tags: ['nature', 'hikes'], budget: 2, people: 'couple', duration: '9 days', createdDaysAgo: 2, saves: 341 },
  { id: 2, title: 'Lisbon Coffee Crawl', author: 'Marco T.', authorImg: 'https://i.pravatar.cc/60?img=12', country: 'Portugal', city: 'Lisbon', imageUrl: 'https://images.unsplash.com/photo-1585208798174-6cedd86e019a?w=700&q=80&auto=format&fit=crop', tags: ['coffee', 'food', 'city'], budget: 1, people: 'solo', duration: '4 days', createdDaysAgo: 5, saves: 212 },
  { id: 3, title: 'Kyoto in Cherry Blossom', author: 'Aiko N.', authorImg: 'https://i.pravatar.cc/60?img=45', country: 'Japan', city: 'Kyoto', imageUrl: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=700&q=80&auto=format&fit=crop', tags: ['culture', 'city'], budget: 3, people: 'small group', duration: '6 days', createdDaysAgo: 1, saves: 498 },
  { id: 4, title: 'Ubud Jungle Reset', author: 'Sana K.', authorImg: 'https://i.pravatar.cc/60?img=25', country: 'Indonesia', city: 'Ubud', imageUrl: 'https://images.unsplash.com/photo-1537953773345-d172ccf13cf1?w=700&q=80&auto=format&fit=crop', tags: ['nature', 'hikes'], budget: 1, people: 'solo', duration: '7 days', createdDaysAgo: 9, saves: 156 },
  { id: 5, title: 'Marrakesh Market Route', author: 'Youssef B.', authorImg: 'https://i.pravatar.cc/60?img=51', country: 'Morocco', city: 'Marrakesh', imageUrl: 'https://images.unsplash.com/photo-1539020140153-e479b8c22e70?w=700&q=80&auto=format&fit=crop', tags: ['food', 'city'], budget: 1, people: 'couple', duration: '5 days', createdDaysAgo: 14, saves: 203 },
  { id: 6, title: 'Chamonix Alpine Weekend', author: 'Elise D.', authorImg: 'https://i.pravatar.cc/60?img=41', country: 'France', city: 'Chamonix', imageUrl: 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=700&q=80&auto=format&fit=crop', tags: ['nature', 'hikes'], budget: 3, people: 'small group', duration: '3 days', createdDaysAgo: 3, saves: 167 },
  { id: 7, title: 'Shibuya Sky & Rooftops', author: 'Kenji M.', authorImg: 'https://i.pravatar.cc/60?img=15', country: 'Japan', city: 'Tokyo', imageUrl: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=700&q=80&auto=format&fit=crop', tags: ['city', 'food'], budget: 2, people: 'couple', duration: '6 days', createdDaysAgo: 20, saves: 389 },
  { id: 8, title: 'Porto Bookstores & Wine', author: 'Ines P.', authorImg: 'https://i.pravatar.cc/60?img=29', country: 'Portugal', city: 'Porto', imageUrl: 'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=700&q=80&auto=format&fit=crop', tags: ['culture', 'food', 'coffee'], budget: 1, people: 'solo', duration: '3 days', createdDaysAgo: 6, saves: 98 },
  { id: 9, title: 'Santorini Sunset Loop', author: 'Nadia G.', authorImg: 'https://i.pravatar.cc/60?img=38', country: 'Greece', city: 'Santorini', imageUrl: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=700&q=80&auto=format&fit=crop', tags: ['beach', 'city'], budget: 3, people: 'couple', duration: '5 days', createdDaysAgo: 1, saves: 512 },
  { id: 10, title: 'Big Sur Coastal Drive', author: 'Owen R.', authorImg: 'https://i.pravatar.cc/60?img=6', country: 'USA', city: 'Big Sur', imageUrl: 'https://images.unsplash.com/photo-1500534623283-312aade485b7?w=700&q=80&auto=format&fit=crop', tags: ['nature', 'hikes'], budget: 2, people: 'large group', duration: '4 days', createdDaysAgo: 11, saves: 274 },
  { id: 11, title: 'Manhattan Long Weekend', author: 'Priya S.', authorImg: 'https://i.pravatar.cc/60?img=48', country: 'USA', city: 'New York', imageUrl: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=700&q=80&auto=format&fit=crop', tags: ['city', 'nightlife', 'food'], budget: 3, people: 'small group', duration: '4 days', createdDaysAgo: 17, saves: 231 },
  { id: 12, title: 'Fes Medina Deep Dive', author: 'Hamid L.', authorImg: 'https://i.pravatar.cc/60?img=52', country: 'Morocco', city: 'Fes', imageUrl: 'https://images.unsplash.com/photo-1489493887464-892be6d1daae?w=700&q=80&auto=format&fit=crop', tags: ['culture', 'food'], budget: 1, people: 'solo', duration: '3 days', createdDaysAgo: 25, saves: 87 },
];

export const exploreRecommendations: ExploreRecommendation[] = [
  { tripId: 1, why: 'Because you liked Iceland' },
  { tripId: 3, why: 'Popular this month' },
  { tripId: 9, why: 'Matches your beach trips' },
  { tripId: 6, why: 'Nearby your Alps trip' },
];

export const exploreTags = ['coffee', 'food', 'nature', 'hikes', 'city', 'beach', 'culture', 'nightlife'];

export const budgetOptions = [
  { value: 1, label: '$ Budget', symbol: '$' },
  { value: 2, label: '$$ Moderate', symbol: '$$' },
  { value: 3, label: '$$$ Premium', symbol: '$$$' },
] as const;

export const peopleOptions = [
  { value: 'solo', label: 'Solo' },
  { value: 'couple', label: 'Couple' },
  { value: 'small group', label: 'Small group (3–5)' },
  { value: 'large group', label: 'Large group (6+)' },
] as const;

export const sortOptions = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'most-saved', label: 'Most saved' },
  { value: 'budget-low', label: 'Budget: low to high' },
  { value: 'budget-high', label: 'Budget: high to low' },
] as const;

export type ExploreSort = typeof sortOptions[number]['value'];
export type ExplorePeople = typeof peopleOptions[number]['value'];

export const formatDaysAgo = (days: number) => {
  if (days <= 0) return 'Today';
  if (days === 1) return '1 day ago';
  return `${days} days ago`;
};

export const getBudgetSymbol = (budget: ExploreTrip['budget']) =>
  budgetOptions.find((option) => option.value === budget)?.symbol || '$';
